<template>
    <div>
        <el-input
                class="input new_password"
                @blur="affirm_password_blur"
                v-model="userPassword"
                placeholder="请输入原密码"
                maxlength="16"
                show-password
        ></el-input>
        <el-input
                class="input new_password"
                @input="password_dsafety"
                @blur="affirm_password_blur"
                v-model="new_password"
                placeholder="请输入新密码"
                maxlength="16"
                show-password
        ></el-input>
        <div class="passwor_dsafety">
            <div :class="{ on: dsafety>=1 }">弱</div>
            <div :class="{ on: dsafety>=2 }">中</div>
            <div :class="{ on: dsafety>=3 }">强</div>
        </div>
        <el-input
                @blur="affirm_password_blur"
                :class="['input','affirm_password',affirm==1?'affirm':'' ]"
                v-model="affirm_password"
                placeholder="确认新密码"
                type="password"
                maxlength="16"
        ></el-input>
        <div v-if="affirm==2" class="hint">新密码与确认密码不一致请重新输入</div>
        <div class="account-butn" @click="Confirm_changes()">确认更改</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                userPassword:'',
                new_password: "",
                affirm_password: "",
                dsafety: 0,
                affirm: 0,
                verify:true,
                time:60
            };
        },
        methods: {
            password_dsafety(e) {
                this.dsafety = 0;
                if (e.length >= 8) {
                    var regNumber = /\d+/;
                    var regLower = /[a-z]+/;
                    var regUpper = /[A-Z]+/;
                    if (regNumber.test(e)) {
                        this.dsafety++;
                    }
                    if (regLower.test(e)) {
                        this.dsafety++;
                    }
                    if (regUpper.test(e)) {
                        this.dsafety++;
                    }
                }
            },
            affirm_password_blur() {
                if (this.new_password != "" && this.affirm_password != "") {
                    if (this.new_password == this.affirm_password) {
                        this.affirm = 1;
                    } else {
                        this.affirm = 2;
                    }
                } else {
                    this.affirm = 0;
                }
            },
            Confirm_changes(){
                this.$SIF.httpPost({
                    url: this.$SIF._serve.usermanage + "/user/updatePassWord",
                    data: {
                        newUserPassword:this.new_password,
                        userPassword:this.userPassword
                    },
                    succFun: res => {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    },failFun:res=>{
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            }
        }
    };
</script>
<style scoped type="text/css">

    .hint {
        color: #ff1111;
        font-size: 12px;
        margin-top: 10px;
        line-height: 14px;
    }

</style>
<style>

</style>